import React from 'react';
import { observer } from 'src/utils/mobx-react';
import FLAGS from 'src/components/CountryDropdown/assets/flags.png';
import { DateTime } from 'src_common/utils/time/time';
import { StaffAccountBasicDataType, StaffAccountWalletDataType } from 'src/AppState/sdk/staff';
import { useCommon } from 'src/AppState/Common';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';

interface CustomerSummaryTabType {
    basicCustomerData: StaffAccountBasicDataType | null;
    customerWalletData: StaffAccountWalletDataType | null;
    customerId: number;
}

export const CustomerSummaryTabCustomerData = observer(
    'CustomerSummaryTabCustomerData',
    ({ basicCustomerData, customerWalletData, customerId }: CustomerSummaryTabType) => {
        const common = useCommon();
        const {
            config: { personalId, fullNameProperties, cpfProperties },
            universe,
        } = ConfigState.get(common);

        const telebettingId = basicCustomerData?.telebettingId ?? null;
        const telebettingPassword = basicCustomerData?.telebettingPassword ?? null;
        const incomeaccess = basicCustomerData?.incomeaccess ?? null;
        const promoID = basicCustomerData?.promoID ?? null;
        const cpf = basicCustomerData?.cpf ?? null;
        const fullName =
            fullNameProperties === true
                ? basicCustomerData?.fullName
                : `${basicCustomerData?.firstName} ${basicCustomerData?.surname}`;

        return (
            <dl className='customer-data'>
                <dt>Account ID:</dt>
                <dd data-test='account-data-account-id'>
                    <span className='badge badge__success'>
                        {universe}
                        {customerId}
                    </span>
                </dd>
                {telebettingId === null ? null : (
                    <>
                        <dt>Telebetting ID:</dt>
                        <dd> {telebettingId}</dd>
                    </>
                )}

                {telebettingPassword === null ? null : (
                    <>
                        <dt>Telebetting password:</dt>
                        <dd> {telebettingPassword}</dd>
                    </>
                )}

                <dt>Name:</dt>
                <dd data-test='account-data-full-name'>{fullName}</dd>

                {personalId === true ? (
                    <>
                        <dt>Personal ID:</dt>
                        <dd>{basicCustomerData?.personalId}</dd>
                    </>
                ) : null}

                <dt>Mobile number:</dt>
                <dd data-test='account-data-mobile-number'>
                    <span
                        className={`famfamfam-flags ${basicCustomerData?.mobilePhone?.country.toLowerCase()}`}
                        style={{ backgroundImage: `url(${FLAGS})` }}
                    />
                    +{basicCustomerData?.mobilePhone?.prefix} {basicCustomerData?.mobilePhone?.number}
                </dd>

                <dt>Date of birth:</dt>
                <dd data-test='account-data-date-of-birth'>{basicCustomerData?.birthDate}</dd>

                <dt>Postcode:</dt>
                <dd data-test='account-data-postcode'>{basicCustomerData?.postCode}</dd>
                <dt>Registration Date:</dt>
                <dd data-test='account-data-registration-date'>
                    {DateTime.from(customerWalletData?.createdAt)?.format('YYYY-MM-DD')}
                </dd>
                {cpfProperties === true ? (
                    <>
                        <dt>CPF:</dt>
                        <dd data-test='account-data-cpf'>{cpf}</dd>
                    </>
                ) : null}
                {incomeaccess === null
                    ? null
                    : [
                          <dt key='affiliate-title'>Affiliate ID:</dt>,
                          <dd
                              key='affiliate-value'
                              data-test='account-data-affiliate-id'
                          >
                              {incomeaccess}
                          </dd>,
                      ]}

                {promoID === null ? null : (
                    <>
                        <dt>Registration Promo ID:</dt>
                        <dd> {promoID}</dd>
                    </>
                )}
            </dl>
        );
    }
);
